import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';


import { TransitionProps } from '@material-ui/core/transitions'
import { Button } from "../..";
import { CardMedia, makeStyles } from "@material-ui/core";
import Grow from '@material-ui/core/Grow';
//@ts-ignore
const Transition = React.forwardRef<HTMLElement, TransitionProps>((props, ref) => <Grow ref={ref} {...props} />);



export interface CustomImagePreviewProps {
    images: string | string[];
    show?: boolean;
    OnButtonClick?: () => void;
}
const useStyles = makeStyles((theme) => ({
    content: {
        height: 500,
        width: 500,
        [theme.breakpoints.up('md')]: {
            height: 500,
            width: 500
        },
        [theme.breakpoints.down('md')]: {
            height: 350,
            width: 350
        },
        [theme.breakpoints.down('sm')]: {
            height: 200,
            width: 200
        }
    }
}));


export default function CustomImagePreview(props: CustomImagePreviewProps): JSX.Element {
    const { images, show, OnButtonClick, ..._rest } = props

    const [keepOpen, setKeepOpen] = React.useState(show || false);


    const classes = useStyles();


    var image = images as string;
    if (images && Array.isArray(images)) {
        image = images[0];
    }

    React.useEffect(() => {
        setKeepOpen(show!)
    }, [show])

    const handleClose = () => {
        OnButtonClick && OnButtonClick()
        setKeepOpen(false)
    };
    return (
        <Dialog
            open={keepOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => {
                handleClose();
            }}>

            <CardMedia image={image} className={classes.content} alt="no preview" component='img' />

            <DialogActions>

                <Button
                    color="default"
                    onClick={handleClose} >
                    close
                </Button>


            </DialogActions>
        </Dialog>)
}